import {Component, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {ToolbarModule} from "primeng/toolbar";
import {AuthService} from "../../../services/auth.service";

@Component({
    selector: 'app-error-page',
    standalone: true,
    imports: [CommonModule, ToolbarModule],
    templateUrl: './error-page.component.html',
    styleUrl: './error-page.component.scss'
})
export class ErrorPageComponent implements OnInit {

    constructor(private authService: AuthService) {
    }

    ngOnInit(): void {
        this.authService.logout();
    }

    logout(): void {
        this.authService.logout();
    }
}
